
export default {
    checkImgSuffix(fileName){
      const imgSuffix = ['jpg','jpeg','png','gif'];
      let suffix = fileName.substring(fileName.lastIndexOf('.')+1)
      let result = false;
      imgSuffix.forEach(item => {
        if(item == suffix){
          result = true;
          return result;
        }
      });
      return result;
    },
    isEmpty(query){
      if(query == undefined){
        return true;
      }
      if(query == null){
        return true;
      }
      if(query == ''){
        return true;
      }
      return false;
    },
    coverImgSizeLimit(size){
      if(size/(1024*1024) <5){
        return true;
      }
      return false;
    },
    isMobile() {
      this.flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if(this.flag === null) {
        return false;
      }else {
        return true;
      }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js